import { RepositoryUtils } from '../utils/RepositoryUtils';
import { MedeaType } from '../types/MedeaTypes';
import {HomeResumeType, ResumeType} from '../types/ResumeTypes';

const ivyApiDomain = process.env.REACT_APP_IVY_APP_SERVER_API_DOMAIN;

export const uploadImage = (token: string, file: File) => {
  return RepositoryUtils.axiosPost<MedeaType>(
    `${ivyApiDomain}/api/v1/media`,
    {
      file: file,
    },
    { headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${token}` } },
  );
};

export const fetchResumes = (token: string) => {
  return RepositoryUtils.axiosGet<ResumeType[]>(
      `${ivyApiDomain}/api/v1/resume/all`,
      { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const postResume = (token: string, data: ResumeType) => {
  return RepositoryUtils.axiosPost<ResumeType>(
      `${ivyApiDomain}/api/v1/resume`,
      // `api/v1/resume`,
      {...data},
      { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const putResume = (token: string, id: number, data: ResumeType) => {
  return RepositoryUtils.axiosPut<ResumeType>(
      `${ivyApiDomain}/api/v1/resume/${id}`,
    // `api/v1/resume/${id}`,
    {...data},
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const fetchHomeResume = (token: string) => {
  return RepositoryUtils.axiosGet<HomeResumeType>(`${ivyApiDomain}/api/v1/home`, { headers: { Authorization: `Bearer ${token}` } })
}
